import {
  ADD_STUDENT_REQUEST,
  ADD_STUDENT_SUCCESS,
  ADD_STUDENT_FAIL,
  GET_STUDENT_REQUEST,
  GET_STUDENT_SUCCESS,
  GET_STUDENT_FAIL,
  GET_BATCH_STUDENT_REQUEST,
  GET_BATCH_STUDENT_SUCCESS,
  GET_BATCH_STUDENT_FAIL,
  UPDATE_STUDENT_REQUEST,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_FAIL,
  DELETE_STUDENT_REQUEST,
  DELETE_STUDENT_SUCCESS,
  DELETE_STUDENT_FAIL,
  CLEAR_ERRORS,
  }  from "../../constants/admin/studentConstants"

export const studentReducer = (state = { students: [] }, action) => {
  switch (action.type) {
    case ADD_STUDENT_REQUEST:
    case GET_STUDENT_REQUEST:
    case GET_BATCH_STUDENT_REQUEST:
    case UPDATE_STUDENT_REQUEST:
    case DELETE_STUDENT_REQUEST:
      return { ...state, loading: true };

    case ADD_STUDENT_SUCCESS:
      return { ...state, loading: false, success: true, student: action.payload };

    case GET_STUDENT_SUCCESS:
    case GET_BATCH_STUDENT_SUCCESS:
      return { ...state, loading: false, students: action.payload};

    case UPDATE_STUDENT_SUCCESS:
      return { ...state, loading: false, success: true, student: action.payload };

    case DELETE_STUDENT_SUCCESS:
      return {
        ...state,
        students: state.students.filter(student => student._id !== action.payload),
      };

    case ADD_STUDENT_FAIL:
    case GET_STUDENT_FAIL:
    case GET_BATCH_STUDENT_FAIL:
    case UPDATE_STUDENT_FAIL:
    case DELETE_STUDENT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};

